import { cva } from 'class-variance-authority';

export const typographyVariants = cva('', {
  variants: {
    size: {
      xss: 'text-xss leading-xss',
      xs: 'text-xs leading-xs',
      sm: 'text-sm leading-sm',
      md: 'text-md leading-md',
      lg: 'text-lg leading-lg',
      xl: 'text-xl leading-xl',
      '2xl': 'text-2xl leading-2xl',
      '3xl': 'text-3xl leading-3xl',
    },
    weight: {
      regular: 'font-normal',
      bold: 'font-bold',
    },
    font: {
      'sf-display-pro': 'font-sf-display-pro',
      quicksand: 'font-quicksand',
    },
  },
  defaultVariants: {
    size: 'md',
    weight: 'regular',
    font: 'quicksand',
  },
});
